<template>
    <DadosBancariosShared ref="dadosBancariosShared" tipoCliente="Pessoa Física" :Edicao="Edicao" />
</template>

<script>
import DadosBancariosShared from '@/views/Cadastro/Shared/DadosBancarios.vue'

export default {
    name: 'CadastroPF_DadosBancarios',
    components: { DadosBancariosShared },
    props: ['Edicao'],
    methods: {
        proximaEtapa() {
            if (this.$refs.dadosBancariosShared?.proximaEtapa) {
                this.$refs.dadosBancariosShared.proximaEtapa();
            }
        },
        validarFormulario(submeter) {
            if (this.$refs.dadosBancariosShared?.validarFormulario) {
                return this.$refs.dadosBancariosShared.validarFormulario(submeter);
            }
            return false;
        },
        salvarInformacoes() {
            if (this.$refs.dadosBancariosShared?.salvarInformacoes) {
                this.$refs.dadosBancariosShared.salvarInformacoes();
            }
        }
    }
}
</script>
